export default __webpack_public_path__ + "locales/sq-AL/VersionHistory.json?hash=ca27f7a89c3caef72f744afa75543ab2";